import SDIcon from './SDIcon'

const IconCarbonCalendar = (props) => (
  <SDIcon title='Calendar' {...props}>
    <path d='M26,4h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V6C28,4.9,27.1,4,26,4z M26,26H6V12h20V26z M26,10H6V6h4v2h2V6h8v2h2V6h4V10z' />
  </SDIcon>
)

export default IconCarbonCalendar
